import React, { Fragment } from 'react';
import { Grid, Row, Col} from 'react-bootstrap';
import MapBanner from './shared/MapBanner';
import NewsCategoryExplorer from './news/NewsCategoryExplorer';
import BestFriend from './shared/BestFriend';
import NewsCardsSlider from './news/NewsCardsSlider';
import BwRewards from './events/BwRewards';

const newsBannerImage = require('./../../images/news_banner.jpg');

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import { customerJourneyNewsCategories, customerJourneyNewsCategory } from '../../actions';

import './news.scss';

class News extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentCategoryId: null
    };
  }

  /* Lifecycle */
  componentWillMount() {

    const { actions, token, currentLanguage, context } = this.props

    actions.customerJourneyNewsCategories(token, currentLanguage, context, (newsCategories) => {
      if(newsCategories.length > 0) {
        const firstCategoryId = newsCategories[0].id;
        actions.customerJourneyNewsCategory(firstCategoryId, token, currentLanguage, context);
        this.setState({currentCategoryId: firstCategoryId});
      }
    });
  }

  render() {

    const { translate, loading, newsCategoriesCount } = this.props

    const noNews = (
      <div>
        <br/>
        <h2 className="text-center">{translate('news.no_news')}</h2>
        <br/>
      </div>
    );

    const news = (
      <Fragment>
        <NewsCategoryExplorer currentCategoryId={this.state.currentCategoryId} onChangeCurrentCategoryId={(catId) => { this.setState({currentCategoryId: catId}); }}/>
        <NewsCardsSlider />
      </Fragment>
    )

    const bannerImageStyle = { backgroundImage: `url(${newsBannerImage})` };

    return (
      <Grid className="news-component">
        <Row className="news-banner">
          <div className="news-banner__image-holder" style={bannerImageStyle}>

            <div className="news-banner__overlay"></div>

            <Col sm={6}>
              <div className="news-banner__text-holder">
                <div>
                  <h4>{this.props.translate('news.header')}</h4>

                  <div className="news-banner__text">
                    <h3>
                      {this.props.translate('news.title')}
                    </h3>
                    <br/>
                    <h5>{this.props.translate('news.text')}</h5>
                  </div>
                </div>
              </div>
            </Col>

          </div>
        </Row>

                  
        {
          !loading 
            ? newsCategoriesCount > 0 ? news : noNews 
            : news  
        }

        <br/>
        <br/>
        <br/>

        {/* <BwRewards/> */}

        <BestFriend/>

      </Grid>
    );
  }
}

News.displayName = 'PagesNews';
News.propTypes = {};
News.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      token: state.commons.token,
      context: state.commons.context,
      translate: getTranslate(state.locale),
      newsCategoriesCount: state.newsCategories.apiData.length,
      loading: state.newsCategories.loading
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyNewsCategories: bindActionCreators(customerJourneyNewsCategories, dispatch),
      customerJourneyNewsCategory: bindActionCreators(customerJourneyNewsCategory, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(News);



// WEBPACK FOOTER //
// ./components/pages/News.js